import React from "react";

import WhatsAppIcon from "./WhatsAppIcon";
import { promoCopy } from "./copy";
import { isOfferActive, whatsAppLink } from "../../constants/promo";
import "../../assets/css/promo.css";

/*
  Permanent bar for the length of the campaign, fixed above the navbar so
  it is the first thing on screen. The `ctp-on` class on <body> is what
  pushes the navbar, sidebar and main content down to make room for it —
  see promo.css. No dismiss control by design: it is the fallback for
  everyone who closes the popup.

  The language switcher sits outside the <a>, because a button nested in an
  anchor is invalid markup and every click would open WhatsApp instead.
*/
class OfferStickyBar extends React.Component {
  componentDidMount() {
    if (isOfferActive()) {
      document.body.classList.add("ctp-on");
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("ctp-on");
  }

  render() {
    if (!isOfferActive()) {
      return null;
    }

    const { lang, onToggleLang } = this.props;
    const t = promoCopy(lang);
    const rtl = t.dir === "rtl";

    return (
      <div
        className={`ctp-bar ${rtl ? "ctp-rtl" : "ctp-ltr"}`}
        dir={t.dir}
        lang={lang}
      >
        <a
          className="ctp-bar-main"
          href={whatsAppLink(lang)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="ctp-bar-glow" />
          <span className="ctp-bar-shine" />

          <span className="ctp-bar-tag">{t.tag}</span>

          <span className="ctp-bar-copy">
            <span className="ctp-bar-l1">
              <span className="ctp-wide">
                {t.head1} {t.head2} <em>{t.head3}</em>
              </span>
              <span className="ctp-narrow">
                {t.barFrom} <em>{t.price}</em> {t.periodShort}
              </span>
            </span>

            <span className="ctp-bar-l2">
              <span className="ctp-wide">{t.sub}</span>
              <span className="ctp-narrow">{t.barTap}</span>
            </span>
          </span>

          <span className="ctp-bar-price">
            {t.price} <small>{t.periodShort}</small>
          </span>

          <span className="ctp-bar-cta">
            <WhatsAppIcon />
            {t.cta}
            {/* dir=ltr so the number is not reordered inside Arabic text */}
            <span className="ctp-bar-cta-num" dir="ltr">
              +974 3012 6301
            </span>
          </span>
        </a>

        <button
          type="button"
          className="ctp-lang"
          onClick={onToggleLang}
          title={t.switchTo}
          aria-label={t.switchTo}
        >
          <span className="ctp-lang-long">{t.switchTo}</span>
          <span className="ctp-lang-short">{t.switchToShort}</span>
        </button>
      </div>
    );
  }
}

export default OfferStickyBar;
